import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {

    /************* LOCAL *************/
    // type = 'LOCAL';
    // apiRoot = 'http://localhost:9005';
    // slaRoot = 'http://localhost:9080/ifixSlaApplication';
    // externalRoot = 'http://localhost:9080/ifixExternalAPIManagement';
    // reportRoot = 'http://localhost:9080/ifixReportApplication';
    // indexRoot = 'http://localhost:9080/ifixDMApplication';
    // userUploadRoot = 'http://localhost:9080/BulkUserCreationAndModification';
    // API_ROOT = 'http://localhost:4200';
    // SOCKET_IP = 'http://localhost:9007';
    // UPLOAD_PATH_BASE = 'https://ifix-uat.s3.amazonaws.com/';

    // type = 'LOCAL';
    // apiRoot = 'http://192.168.29.17:9005';
    // slaRoot = 'http://192.168.29.17:9080/ifixSlaApplication';
    // reportRoot = 'http://192.168.29.17:9080/ifixReportApplication';
    // API_ROOT = 'http://192.168.29.17:4200';
    // SOCKET_IP = 'http://192.168.29.17:9007';
    // UPLOAD_PATH_BASE = 'https://ifix-uat.s3.amazonaws.com/';

    /************* STAGING *************/
    // type = 'LOCAL';
    // slaRoot = 'http://3.6.180.95:9080/ifixSlaApplication';
    // reportRoot = 'http://3.6.180.95:9080/ifixReportApplication';
    // indexRoot = 'http://3.6.180.95:9080/ifixDMApplication';
    // apiRoot = 'http://3.6.180.95:9005';
    // API_ROOT = 'http://3.6.180.95:9000';
    // SOCKET_IP = 'http://3.6.180.95:9007';
    // UPLOAD_PATH_BASE = 'https://ifix-uat.s3.amazonaws.com/';
    /************* TCS STAGING *************/
    // type = 'LOCAL';
    // slaRoot = 'http://3.7.143.3:8080/ifixSlaApplication';
    // reportRoot = 'http://3.7.143.3:8080/ifixReportApplication';
    // indexRoot = 'http://3.7.143.3:8080/ifixDMApplication';
    // apiRoot = 'http://3.7.143.3:9005';
    // API_ROOT = 'http://3.7.143.3:9000';
    // SOCKET_IP = 'http://3.7.143.3:9007';
    // UPLOAD_PATH_BASE = 'https://ifix-uat.s3.amazonaws.com/';
    /************* UAT2 *************/
    // type = 'UAT';
    // apiRoot = 'https://uat2.ifixcloud.co:9005';
    // slaRoot = 'http://uat2.ifixcloud.co:9080/ifixSlaApplication';
    // externalRoot = 'http://uat2.ifixcloud.co:9080/ifixExternalAPIManagement';
    // reportRoot = 'http://uat2.ifixcloud.co:9080/ifixReportApplication';
    // indexRoot = 'http://uat2.ifixcloud.co:9080/ifixDMApplication';
    // userUploadRoot = 'http://uat2.ifixcloud.co:9080/BulkUserCreationAndModification';
    // API_ROOT = 'https://uat2.ifixcloud.co';
    // SOCKET_IP = 'https://uat2.ifixcloud.co:9007';
    // UPLOAD_PATH_BASE = 'https://ifix-uat.s3.amazonaws.com/';
    /************* PRODUCTION ***********/

    // type = 'UAT';
    // apiRoot = 'https://uat3.ifixcloud.co:9005';
    // slaRoot = 'https://uat3.ifixcloud.co:9080/ifixSlaApplication';
    // externalRoot = 'https://uat3.ifixcloud.co:9080/ifixExternalAPIManagement';
    // reportRoot = 'https://uat3.ifixcloud.co:9080/ifixReportApplication';
    // indexRoot = 'https://uat3.ifixcloud.co:9080/ifixDMApplication';
    // userUploadRoot = 'https://uat3.ifixcloud.co:9080/BulkUserCreationAndModification';
    // API_ROOT = 'https://uat3.ifixcloud.co';
    // SOCKET_IP = 'https://uat3.ifixcloud.co:9007';
    // UPLOAD_PATH_BASE = 'https://ifix-uat.s3.amazonaws.com/';

    // type = 'PROD';
    // apiRoot = 'https://uat3.ifixcloud.co:9005';
    // slaRoot = 'http://uat3.ifixcloud.co:9080/ifixSlaApplication';
    // externalRoot = 'http://uat3.ifixcloud.co:9080/ifixExternalAPIManagement';
    // reportRoot = 'http://uat3.ifixcloud.co:9080/ifixReportApplication';
    // indexRoot = 'http://uat3.ifixcloud.co:9080/ifixDMApplication';
    // userUploadRoot = 'http://uat3.ifixcloud.co:9080/BulkUserCreationAndModification';
    // API_ROOT = 'https://uat3.ifixcloud.co';
    // SOCKET_IP = 'https://uat3.ifixcloud.co:9007';
    // UPLOAD_PATH_BASE = 'https://ifix-uat.s3.amazonaws.com/';




    /************* UATNEW *************/
    // type = 'UAT';
    // apiRoot = 'https://uat3.ifixcloud.co/api';
    // slaRoot = 'https://uat3.ifixcloud.co/java_api/ifixSlaApplication';
    // externalRoot = 'https://uat3.ifixcloud.co/java_api/ifixExternalAPIManagement';
    // reportRoot = 'https://uat3.ifixcloud.co/java_api/ifixReportApplication';
    // indexRoot = 'https://uat3.ifixcloud.co/java_api/ifixDMApplication';
    // userUploadRoot = 'https://uat3.ifixcloud.co:9080/BulkUserCreationAndModification';
    // API_ROOT = 'https://uat3.ifixcloud.co';
    // SOCKET_IP = 'https://uat3.ifixcloud.co:9007';
    // UPLOAD_PATH_BASE = 'https://ifix-uat.s3.amazonaws.com/';


    /************* PRODUCTION ***********/
    type = 'PROD';
    apiRoot = 'https://lntssc.ifixcloud.co:9005';
    slaRoot = 'https://lntssc.ifixcloud.co:9080/ifixSlaApplication';
    externalRoot = 'https://lntssc.ifixcloud.co:9080/ifixExternalAPIManagement';
    reportRoot = 'http://lntssc.ifixcloud.co:9080/ifixReportApplication';
    indexRoot = 'http://lntssc.ifixcloud.co:9080/ifixDMApplication';
    userUploadRoot = 'http://lntssc.ifixcloud.co:9080/BulkUserCreationAndModification';
    API_ROOT = 'https://lntssc.ifixcloud.co';
    SOCKET_IP = 'https://lntssc.ifixcloud.co:9007';
    UPLOAD_PATH_BASE = 'https://ifix-prod.s3.amazonaws.com/';
    generateReportRoot = 'https://lntssc.ifixcloud.co:9005';



    // type = 'PROD';
    // apiRoot = 'https://lnttemp.ifixcloud.co:9005';
    // geenrateReportRoot = 'https://lnttemp.ifixcloud.co/sd';
    // slaRoot = 'https://lnttemp.ifixcloud.co:9080/ifixSlaApplication';
    // externalRoot = 'https://lnttemp.ifixcloud.co:9080/ifixExternalAPIManagement';
    // reportRoot = 'http://lnttemp.ifixcloud.co:9080/ifixReportApplication';
    // indexRoot = 'http://lnttemp.ifixcloud.co:9080/ifixDMApplication';
    // userUploadRoot = 'http://lnttemp.ifixcloud.co:9080/BulkUserCreationAndModification';
    // API_ROOT = 'https://lnttemp.ifixcloud.co';
    // SOCKET_IP = 'https://lnttemp.ifixcloud.co:9007';
    // UPLOAD_PATH_BASE = 'https://ifix-prod.s3.amazonaws.com/';

    // constructor() {
    // }
}


